(function()  {

    'use strict';

    const Team = function (element) {

        // The passport object itself
        this.element = element;

        /// The present action of the dialog modal
        this.trigger = element.getElementsByTagName('BUTTON')[0];

        /// The dismiss action for the dialog modal
        this.close = element.getElementsByClassName('close__action')[0];

        /// The dialog modal of the passport
        this.modal = element.getElementsByClassName('member__modal')[0];

        this.presentModal = this.presentModal.bind(this);
        this.dismissModal = this.dismissModal.bind(this);

        this.initiateListener();
    }

    /**
     * Starts listening
     */
    Team.prototype.initiateListener = function () {

        if (this.trigger !== undefined) {
            this.trigger.addEventListener('pointerdown', this.presentModal);
        }
    }

    /**
     * Shows the modal.
     */
    Team.prototype.presentModal = function (event) {

        let present = false;

        if (event.type === 'keydown' && event.key === 'Enter') {
            present = true;
        }

        if (event.type === 'pointerdown' && !this.modal.open) {
            present = true;
        }

        if (present) {

            this.modal.showModal();

            window.addEventListener('pointerdown', this.dismissModal);

            this.close.addEventListener('pointerdown', this.dismissModal);
        }
    }

    /**
     * Dismiss the modal.
     */
    Team.prototype.dismissModal = function (event) {

        if (event.type === 'pointerdown' && this.modal.open && event.target.value === 'close') {

            this.modal.close();

            window.removeEventListener('pointerdown', this.dismissModal);
        }

        if (event.type === 'pointerdown' && this.modal.open && !event.target.closest('.js-team')) {

            this.modal.close();

            window.removeEventListener('pointerdown', this.dismissModal);
        }
    }

    const teams = document.getElementsByClassName('js-team');

    for (const team of teams) {
        new Team(team);
    }

}());